import { DeliveryOrderService } from './../../../../transport-operation/services/delivery-order.service';
import { AirwaysExpenseService } from './../../../service/airways-expense.service';
import { EventEmitter, Injector, Input, Output } from '@angular/core';
import { ViewChild } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { FileUpload } from 'primeng/fileupload';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { UserPreferenceConstants } from 'src/app/core/constants/user-preference-constants.constant';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { CommonService } from '../../../service/common.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { UserType } from 'src/app/core/enums/user-type.enum';
import { getForwarderByPermission } from 'src/app/core/utils/common-functions';

@Component({
  selector: 'laas-airways-expense-setting-import',
  templateUrl: './airways-expense-setting-import.component.html',
  styleUrls: ['./airways-expense-setting-import.component.scss']
})
export class AirwaysExpenseSettingImportComponent extends SessionBaseComponent implements OnInit {

  @ViewChild('fileUpload') fileUpload!: FileUpload;
  @Output() visibleChange: EventEmitter<any>;
  @Output() uploadClick: EventEmitter<any>;

  readonly preferenceKey: string;
  readonly permissionCode: PermissionConstants = PermissionConstants.ViewAirwaysExpenseSetting;

  airwaysExpenseRows: any[];
  forwarder: any;
  importForm: FormGroup;
  forwarderOptions: any[];
  feeTypeOptions: any[];
  currencyOptions: any[];
  countryOptions: any[];
  iataAreaOptions: any[];
  isLoading: boolean;
  isVisible: boolean;
  submitted: boolean;
  columns: any[];

  constructor(
    injector: Injector,
    private commonDataService: CommonDataService,
    private commonService: CommonService,
    private dropdownOptionsService: DropdownOptionsService,
    private airwaysExpenseService: AirwaysExpenseService,
    private DOService: DeliveryOrderService,
    private formBuilder: FormBuilder
  ) {
    super(injector);
    this.preferenceKey = UserPreferenceConstants.AirwaysExpenseSettingImport;
    this.airwaysExpenseRows = [];
    this.forwarder = null;
    this.forwarderOptions = [];
    this.feeTypeOptions = [];
    this.currencyOptions = [];
    this.countryOptions = [];
    this.iataAreaOptions = [];
    this.isLoading = false;
    this.isVisible = false;
    this.submitted = false;
    this.visibleChange = new EventEmitter<any>();
    this.uploadClick = new EventEmitter<any>();

    this.columns = [
      { field: 'feeType', header: 'FSCSSCImport.MainTable.CostType', sort: true },
      { field: 'currency', header: 'FSCSSCImport.MainTable.Currency', sort: true },
      { field: 'amount', header: 'FSCSSCImport.MainTable.Amount', sort: true },
      { field: 'rfqCategory', header: 'FSCSSCImport.MainTable.DocumentType', sort: true },
      { field: 'fromCountry', header: 'FSCSSCImport.MainTable.DepartureCountry', sort: true },
      { field: 'toIataArea', header: 'FSCSSCImport.MainTable.DestinationIATA', sort: true },
      { field: 'remark', header: 'FSCSSCImport.MainTable.Remarks', sort: true },
      { field: 'startDt', header: 'FSCSSCImport.MainTable.EffectiveStart', dataType: 'date', sort: true },
      { field: 'endDt', header: 'FSCSSCImport.MainTable.EffectiveEnd', dataType: 'date', sort: true },
    ];

    this.importForm = this.formBuilder.group({
      forwarder: ['', Validators.required],
    });
  }

  @Input() get visible(): any {
    return this.isVisible;
  }
  set visible(value: any) {
    this.isVisible = value;
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    this.dropdownOptionsService.getForwarderOptions().subscribe({
      next: (options: any[]) => {
        this.forwarderOptions = options.filter((x: any) => {
          return ( this.userProfile.userType === UserType.SuperAdmin.toString() ||
          this.userProfile.userType === UserType.Shipping.toString() ||
           getForwarderByPermission(this.userProfile, this.permissionCode).includes(x.optionCode));
        }).map(x => ({ label: x.optionDesc, value: x.optionCode }));
        this.translateService.get('Common.Message.ChooseOption')
        .subscribe({
          next: msg => {
            this.forwarderOptions.unshift({
              label: msg,
              value: ''
            });
          }
        });

      }
    });

    this.commonService.getFeeType('Airways').subscribe({
      next: result => {
        this.feeTypeOptions = [...result].map((x: any) => {
          return {
            label: `${x.feeTypeCode}-${x.feeTypeName}`,
            value: x.feeTypeCode,
          };
        });
      }
    });

    this.commonService.getCurrencyOptions().subscribe({
      next: result => {
        this.currencyOptions = [...result].map((x: any) => {
          return {
            label: `${x.currency_code}-${x.currency_name}`,
            value: x.currency_code,
          };
        });
      }
    });

    this.dropdownOptionsService.getVCountryOptions().subscribe({
      next: result => {
        this.countryOptions = [...result].map((x: any) => {
          return {
            label: x.countryName,
            value: x.countryCode,
          };
        });
      }
    });

    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'IATAArea').subscribe({
      next: result => {
        this.iataAreaOptions = [...result].map((x: any) => {
          return {
            label: `${x.codeKey}-${x.codeDesc}`,
            value: x.codeKey,
          };
        });
      }
    });
  }

  fileUploader(event: any): void{
    this.isLoading = true;
    this.airwaysExpenseService.importAirwaysExpenseByExcel(event.files[0], this.laasSetting.facility, this.userProfile.userName).subscribe({
      next: result => {
        this.airwaysExpenseRows = result;
      },
      complete: () => {
        this.clearUploadUI();
        this.isLoading = false;
      }
    });
  }

  clearUploadUI(): void{
    this.fileUpload.clear();
  }

  importClickBtn(event: any): void{
    this.submitted = true;
    // check validation
    if (this.importForm.invalid) {
      this.toastService.warn(this.translateService.instant('AirwaysExpenseSetting.Alert.CheckFreightForwarder'));
      return;
    }
    if (this.airwaysExpenseRows.some(x => this.feeTypeOptions.every(y => x.feeType !== y.value))){
      this.toastService.warn(this.translateService.instant('AirwaysExpenseSetting.Alert.CheckFee'));
      return;
    }
    if (this.airwaysExpenseRows.some(x => this.currencyOptions.every(y => x.currency !== y.value))){
      this.toastService.warn(this.translateService.instant('AirwaysExpenseSetting.Alert.CheckCurrency'));
      return;
    }
    if (this.airwaysExpenseRows.some(x => x.amount === null)){
      this.toastService.warn(this.translateService.instant('AirwaysExpenseSetting.Alert.AmountFilled'));
      return;
    }
    if (this.airwaysExpenseRows.some(x => this.countryOptions.every(y => x.fromCountry !== y.value))){
      this.toastService.warn(this.translateService.instant('AirwaysExpenseSetting.Alert.DepartureCountryCorrect'));
      return;
    }
    if (this.airwaysExpenseRows.some(x => this.iataAreaOptions.every(y => x.toIataArea !== y.value))){
      this.toastService.warn(this.translateService.instant('AirwaysExpenseSetting.Alert.DestinationIATACorrect'));
      return;
    }
    if (this.airwaysExpenseRows.some(x => x.startDt > x.endDt)){
      this.toastService.warn(this.translateService.instant('AirwaysExpenseSetting.Alert.CheckDate'));
      return;
    }

    this.airwaysExpenseRows.forEach(x => {
      x.facility = this.laasSetting.facility;
      x.forwarder = this.forwarder;
      this.airwaysExpenseService.addAirwaysExpense(x).subscribe({
        next: result => {
          this.translateService.get('Common.Message.SuccessSave')
              .subscribe({
                next: msg => {
                  this.toastService.success(msg);
                }
              });
        },
        error: err => {
          this.toastErrorMessage(err.error);
        }
      });
    });
    this.airwaysExpenseRows = [];
  }

  dialogVisibleChange(event: any): void{
    this.visibleChange.emit(event);
  }

  templateDownloadClickBtn(event: any): void{
    this.commonDataService.getSystemParam('AirwaysExpenseSetting').subscribe({
      next: result => {
        var searchObj = {
          sn: result[0].sn,
          version: result[0].version
        };

        this.DOService.downloadFile(searchObj).subscribe(x => {
          var blob = new Blob([x], { type: 'application/octet-stream' }); // application後面接下載的副檔名

          let downloadURL = window.URL.createObjectURL(blob);
          let link = document.createElement('a');
          link.href = downloadURL;
          link.download = `AirwaysExpense_Sample.xlsx`;
          link.click();
        });
      }
    });

  }
}
